import type { FC } from 'react';
import cn from 'classnames';
import React, { useEffect } from 'react';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { PlateDesktop as Plate } from '@alfa-bank/site-plate/desktop';
import { NamedContainer } from '@alfa-bank/site-named-container';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/src/desktop';

import { defaultTeenagerSettings } from '../../config/default-values';

import styles from './styles/desktop.css';
import type { ITeenagerPlateProps } from './models';
import { InfoIcon } from './information-circle-m-icon';

export const TeenagerPlateDesktop: FC<ITeenagerPlateProps> = ({
    analytics,
    title = defaultTeenagerSettings.title,
    buttonText = defaultTeenagerSettings.buttonText,
    buttonHref = defaultTeenagerSettings.buttonHref,
}) => {
    useEffect(() => {
        sendEvent(analytics.view);
    }, [analytics.view]);

    // TODO хардкод с отступами нужно убрать когда дизайнеры поправят Plate в своих макетах + сделают задачу для коров
    return (
        <Plate
            border={false}
            className={cn(styles.external, styles.plate)}
            dataTestId="smev-teenager-plate"
            styler={{ borderRadius: 12, marginTop: 24 }}
        >
            <NamedContainer name="leftAddons">
                <Block styler={{ marginTop: 4, padding: 4 }}>
                    <InfoIcon />
                </Block>
            </NamedContainer>
            <NamedContainer name="title">
                <Text styler={{ marginTop: 0, marginBottom: 0 }} view="primary-small">
                    {title}
                </Text>
            </NamedContainer>
            <NamedContainer name="subAddons">
                <Button
                    href={buttonHref}
                    onClick={() => {
                        sendEvent(analytics.buttonClick);
                    }}
                    size="s"
                    target="_blank"
                    view="secondary"
                >
                    {buttonText}
                </Button>
            </NamedContainer>
        </Plate>
    );
};
